<app-nav-logo></app-nav-logo>

<div class="content">

    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-3 col-lg-3"></div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12
                text-center">
                <div class="row">
                    <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <button class="btn-hover color-9" id="TypeCoop" [ngClass]="(TypeCoop
                            ==
                            true)?'active':''" (click)="select_TypeCoop($event.target.id)">ข้อมูลสหกรณ์</button>
                    </div> -->
                    <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <button class="btn-hover color-5" id="TypeAgri" [ngClass]="(TypeAgri
                            ==
                            true)?'active':''" (click)="select_TypeAgri($event.target.id)">ข้อมูลกลุ่มเกษตรกร</button>
                    </div> -->
                </div>
            </div>
            <div class="col-xl-3 col-lg-3"></div>
        </div>
    </div>

    <ng-container *ngIf="TypeCoop">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xl-12">
                    <div class="content-tab">
                        <!-- Nav pills -->
                        <ul class="nav nav-pills" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill" routerLink="">ข้อมูลทั่วไป</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill" routerLink="/Coop-Insert">ค้นหาข้อมูลราย เขต / ภาค</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="pill" routerLink="/Coop-Assets">อุปกรณ์การตลาด</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill" routerLink="/Coop-Machine">เครื่องจักรกลการเกษตร</a>
                            </li>
                        </ul>

                        <!-- Tab panes -->
                        <div class="container-fluid">
                            <div class="row">
                                <div class="tab-content">
                                    <div id="info" class="tab-pane fade">

                                    </div>
                                    <div id="resert" class="tab-pane fade">

                                    </div>
                                    <div id="asset_" class="tab-pane active">
                                        <div class="container">
                                            <div class="row">
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <h5>อุปกรณ์การตลาด</h5>
                                                        </div>

                                                        <div class="card-body">
                                                            <div class="col-xl-12 mb-3
                                                                text-right">
                                                                <h6 class="text-black-50" *ngIf="datayear != undefined">
                                                                    ข้อมูล ณ ปี {{ datayear }}</h6>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-lg-3 col-md-6 col-sm-12 w-100 mt-4">
                                                                    <p class="text-left">เลือกภาค : </p>
                                                                    <select class="form-control"
                                                                        (change)="setphak($event.target.value)">
                                                                        <option>- กรุณาเลือก -</option>
                                                                        <option *ngFor="let items of PhakList"
                                                                            value="{{items.phakId}}">{{items.phakName}}
                                                                        </option>
                                                                    </select>
                                                                </div>

                                                                <div class="col-lg-3 col-md-6 col-sm-12 w-100 mt-4">
                                                                    <p class="text-left">เลือกเขต : </p>
                                                                    <select class="form-control"
                                                                        (change)="setkhet($event.target.value)">
                                                                        <option>- กรุณาเลือก -</option>
                                                                        <option *ngFor="let items of checkkhet"
                                                                            value="{{items.khet_id}}">
                                                                            {{items.khet_desc}}</option>
                                                                    </select>
                                                                </div>

                                                                <div class="col-lg-3 col-md-6 col-sm-12 w-100 mt-4">
                                                                    <p class="text-left">เลือกจังหวัด : </p>
                                                                    <select class="form-control"
                                                                        (change)="setProvince($event.target.value)">
                                                                        <option>- กรุณาเลือก -</option>
                                                                        <option *ngFor="let items of ProvinceByKhet"
                                                                            value="{{items.orgOrgId}}"
                                                                            id="{{items.provinceNameSort}}">
                                                                            {{items.provinceNameSort}}
                                                                        </option>
                                                                    </select>
                                                                </div>

                                                                <div class="col-lg-3 col-md-6 col-sm-12 w-100 mt-4">
                                                                    <p class="text-left">ค้นหา : </p>
                                                                    <button class="btn btn-info w-75"
                                                                        (click)="Search()">
                                                                        <i class="fas fa-search"></i>
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-12">
                                                                <hr>
                                                            </div>


                                                            <div class="card-body" *ngIf="show == true" style="margin-top: -50px;">
                                                                <div class="row" style="margin-bottom: 15px;">
                                                                    <div class="col">
                                                                        <h5 class="mt-2 text-center" style="margin-left: 230px;">รายการอุปกรณ์การตลาด</h5>
                                                                    </div>
                                                                    <div class="col-3 mt-2 text-center" style="text-align: right; margin-right: -30px;">
                                                                        <i class="fa fa-eye fa-2x" aria-hidden="true"
                                                                            style="width: 25px; vertical-align: middle; padding-bottom: 2px; color: black;"></i>
                                                                        จำนวนผู้เข้าชม : {{viewer}} ครั้ง
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <div class="col-xl-4 col-lg-4 col-md-12
                                                                        col-sm-12">
                                                                        <label for="inputPassword"
                                                                            class="col-form-label">ค้นหารายการ</label>
                                                                    </div>
                                                                    <div class="col-xl-8 col-lg-8 col-md-12
                                                                        col-sm-12">
                                                                        <input class="form-control w-100" type="text"
                                                                            name="search" [(ngModel)]="searchText">
                                                                    </div>
                                                                </div>
                                                                <div class="table-responsive">
                                                                    <p class="text-right  mb-1">จำนวนผลลัพธ์การค้นหา :
                                                                        {{sumResult | number:'':'he'}}
                                                                    </p>
                                                                    <table class="table table-hover">
                                                                        <thead>
                                                                            <tr class="table-active">
                                                                                <th scope="col">รายการอุปกรณ์การตลาด
                                                                                </th>
                                                                                <th scope="col">ใช้งาน</th>
                                                                                <th scope="col">ไม่ใช้งาน</th>
                                                                                <th scope="col">หน่วยนับ (จำนวน)
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody *ngFor="let items of
                                                                            pageOfItems | filter:searchText">
                                                                            <tr>
                                                                                <th scope="row">{{items.assetDesc}}</th>
                                                                                <th scope="row">{{items.canUse}}</th>
                                                                                <th scope="row">{{items.canNotUse}}</th>
                                                                                <th scope="row">{{items.qtyUom}}</th>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </div>
                                                            <div class="card-footer">
                                                                <jw-pagination [items]="AssetUseItemYear"
                                                                    (changePage)="onChangePage($event)"></jw-pagination>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div id="machine_" class="tab-pane fade">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="TypeAgri">

    </ng-container>
    <app-footer></app-footer>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">กรุณารอสักครู่. </p>
</ngx-spinner>
